export default __webpack_public_path__ + "static/media/401.24faee0b.png";